import classNames from 'classnames';
import React, { ReactNode } from 'react';
import { FormChangeHandler } from 'src/js/util/global-type';

export enum SDIType {
  NORMAL = 'normal',
  HIGHLIGHT = 'highlight',
  OUTLINE = 'outline',
}

interface MainProps {
  checked?: boolean;
  children?: ReactNode;
  className?: string;
  disabled?: boolean;
  name?: string;
  onChange?: FormChangeHandler;
  type?: SDIType;
  value?: string;
}

export const SdiCheckbox: React.FunctionComponent<MainProps> = ({
  checked,
  children,
  className,
  disabled,
  name,
  onChange,
  type = SDIType.NORMAL,
  value,
  ...rest
}) => {
  return (
    <label className={classNames('sdi-checkbox', 'unselectable', checked && 'checked', type, className)}>
      <input
        disabled={disabled}
        type="checkbox"
        value={value}
        style={{ display: 'none' }}
        name={name}
        checked={checked}
        onChange={onChange}
        {...rest}
      />
      {children}
    </label>
  );
};
